export const CSV_FILE_NAME = 'data.csv';
